export const HTTP_STATUS_TOO_MANY_REQUESTS = 429;

export class RateLimitError extends Error {
	constructor(readonly retryAfterSeconds?: number) {
		super('Too many requests');
		this.name = 'RateLimitError';
	}
}

export const isRateLimitError = (error: unknown): error is RateLimitError =>
	error instanceof RateLimitError;

/**
 * `@nestjs/throttler` suffixes Retry-After with the throttler name unless it is `default`, so every
 * named bucket the backend can 429 with needs an entry or its wait time silently never populates.
 */
export const RETRY_AFTER_HEADERS = [
	'Retry-After',
	'Retry-After-auth-ip',
	'Retry-After-auth-subject',
	'Retry-After-public-signing',
];

/** Just the part of `Response` this reads, so it is callable without a whole fetch Response. */
interface HeaderBearingResponse {
	headers: { get(name: string): string | null };
}

export const rateLimitErrorFrom = (response: HeaderBearingResponse): RateLimitError => {
	for (const header of RETRY_AFTER_HEADERS) {
		const value = response.headers.get(header);
		if (value === null) {
			continue;
		}

		const seconds = Number(value);
		if (Number.isFinite(seconds) && seconds >= 0) {
			return new RateLimitError(seconds);
		}
	}

	return new RateLimitError();
};
